import { IconProps } from './index';

const GlobalLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M6.5 13.25C3.04813 13.25 0.25 10.4519 0.25 7C0.25 3.54813 3.04813 0.75 6.5 0.75C9.95187 0.75 12.75 3.54813 12.75 7C12.75 10.4519 9.95187 13.25 6.5 13.25ZM5.06875 11.7919C4.45213 10.4839 4.09492 9.06888 4.01688 7.625L1.53875 7.625C1.66037 8.58681 2.0587 9.4926 2.68536 10.2323C3.31201 10.972 4.14001 11.5138 5.06875 11.7919ZM5.26875 7.625C5.36312 9.14937 5.79875 10.5813 6.5 11.845C7.2202 10.5478 7.6409 9.10592 7.73125 7.625H5.26875ZM11.4613 7.625H8.98312C8.90508 9.06888 8.54787 10.4839 7.93125 11.7919C8.85999 11.5138 9.68799 10.972 10.3146 10.2323C10.9413 9.4926 11.3396 8.58681 11.4613 7.625ZM1.53875 6.375L4.01688 6.375C4.09492 4.93112 4.45213 3.51605 5.06875 2.20813C4.14001 2.48617 3.31201 3.02797 2.68536 3.76768C2.0587 4.5074 1.66037 5.41319 1.53875 6.375ZM5.26937 6.375H7.73063C7.64047 4.89412 7.21998 3.45221 6.5 2.155C5.7798 3.45216 5.3591 4.89408 5.26875 6.375H5.26937ZM7.93125 2.20813C8.54787 3.51605 8.90508 4.93112 8.98312 6.375H11.4613C11.3396 5.41319 10.9413 4.5074 10.3146 3.76768C9.68799 3.02797 8.85999 2.48617 7.93125 2.20813Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default GlobalLine;
